
import { get } from '../../utils/http'

export function configValues() {
    return get('/config/');
}
